<section class="title-section">
  <h1>{{ 'legal_notice.title' | translate }}</h1>
</section>

<section>
  <h2>{{ 'legal_notice.editor.title' | translate }}</h2>
  <p [innerHTML]="'legal_notice.editor.content' | translate"></p>
</section>

<section>
  <h2>{{ 'legal_notice.publication_director.title' | translate }}</h2>
  <p>{{ 'legal_notice.publication_director.content' | translate }}</p>
</section>

<section>
  <h2>{{ 'legal_notice.development.title' | translate }}</h2>
  <p [innerHTML]="'legal_notice.development.content' | translate"></p>
</section>

<section>
  <h2>{{ 'legal_notice.hosting.title' | translate }}</h2>
  <p [innerHTML]="'legal_notice.hosting.provider' | translate"></p>
  <p [innerHTML]="'legal_notice.hosting.entity' | translate"></p>
  <p [innerHTML]="'legal_notice.hosting.more_info' | translate"></p>
</section>

<section>
  <h2>{{ 'legal_notice.services.title' | translate }}</h2>
  <p>{{ 'legal_notice.services.description' | translate }}</p>
  <ul>
    <li>{{ 'legal_notice.services.item_directory' | translate }}</li>
    <li>{{ 'legal_notice.services.item_booking' | translate }}</li>
  </ul>
</section>

<section>
  <h2>{{ 'legal_notice.personal_data.title' | translate }}</h2>
  <p>{{ 'legal_notice.personal_data.content' | translate }}</p>
  <p>{{ 'legal_notice.personal_data.rights' | translate }}</p>
</section>
